import * as React from 'react';

import { usePointerEvents } from 'components/BackgroundReplacer/SourceTemplate/SimpleEditor/usePointerEvents';

import { ControlProps, Point } from './types';
import { rotateControlSize } from './utils';

const RotateControl: React.FC<ControlProps> = (props) => {
  const handlePointerMove = (point: Point | null): void => {
    if (point) {
      props.onMove(point);
    }
  };

  const [onPointerDown, onPointerMove, onPointerUp] = usePointerEvents({
    center: props.center,
    setTransform: props.transform,
    moveTransform: (x: Point) => x,
    getAreaStartPoint: props.getAreaStartPoint,
    onMove: handlePointerMove,
  });

  return (
    <image
      cursor="grabbing"
      height={rotateControlSize * 2}
      href="/images/rotate.svg"
      transform={props.transformString}
      width={rotateControlSize * 2}
      x={props.center.x - rotateControlSize}
      y={props.center.y - rotateControlSize}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
    />
  );
};

export default RotateControl;
